import { memo } from 'react';
import { Outlet } from 'react-router-dom';

const Organisations_ = () => {
  return <Outlet />;
};

export const Organisations = memo(Organisations_);
